import { Component, OnInit } from "@angular/core";
import { SidebarService } from "@ibe/services/ui";
import { ActivatedRoute, Router } from "@angular/router";
import { INDRABookingService } from "@ibe.services/booking.indra.service";
import {
	ANCILLARY_PRODUCT_GROUP_CODE_KIOSK,
	TRANSLATION_ANCILLARY_DETAILED,
	TRANSLATION_ANCILLARY_GROUP,
	ANCILLARY_GROUP_KIOSK_LIST,
	BRAND_NAMES_MAP,
	SESSION_VAR_KEY_LANGUAGE,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_LANGUAGE,
	DEFAULT_MARKET,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP
} from '@ibe.config';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRASegment } from '@ibe.models/segment.indra.model.lib';
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
import { INDRAIncludedAncillaryDetailForSegment, INDRAIncludedAncillaryCodeCount } from "@ibe.models/ancillary.indra.model.lib";
import { INDRAAncillariesShoppingCartService } from "@ibe.services/ancillaries-shopping-cart.indra.service";
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';

@Component({
	selector: 'app-details-kiosk',
	templateUrl: './details-kiosk.indra.component.html',
	styleUrls: ['./details-kiosk.component.scss']
})
export class INDRADetailsKioskComponent implements OnInit {

	private flightIdentifier: string;
	flight: any;
	flightRouteInput: any;
	passengers: INDRAPax[] = [];
	paxFareInfoFeatures = [];
	paxPurchaseFeatures = [];
	hasLayover = false;
	countUnit = '';
	LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.'
	LOCAL_TRANSLATION_DETAILED_KIOSK = this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE + 'detailsKiosk.'
	paxTierBenefits = [];
	ancillaryGroup: string;
	isMYB: boolean = false;
	isBookingView: boolean = false;
	isReviewTTTCompletion: boolean = false;
	brandDescription: string;
	
	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected bookingService: INDRABookingService,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		public ancillaryCartService: INDRAAncillariesShoppingCartService,
		private bookingSearchService: INDRABookingSearchService
	) { 
		
		if (this.router.url.includes('/my-bookings/view')) this.isBookingView = true;
		if (this.router.url.includes('/review-your-trip/deeplink/')) this.isReviewTTTCompletion = true;
		if (this.router.url.includes('/my-bookings/')) this.isMYB = true;
	}

	ngOnInit() {

		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
		this.flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
		this.passengers = this.bookingService.INDRA_getPaxInfo();
		this.hasLayover = this.INDRA_checkIndirectFlight();
		let fareInfoAncillary = this.bookingService.INDRA_getPassengersAncillaryFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_KIOSK, this.flight.idFlight.toString());
		let tierBenefits = this.bookingService.INDRA_getPassengersTierBenefits(ANCILLARY_PRODUCT_GROUP_CODE_KIOSK);
		let purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_KIOSK, this.flight.idFlight.toString(), this.flightIdentifier);
		this.ancillaryGroup = ANCILLARY_PRODUCT_GROUP_CODE_KIOSK;
		this.brandDescription = this.INDRA_getBrandDescription();

		this.passengers.forEach(pax => {
			const fareInfoindex = fareInfoAncillary.findIndex(
				object => object[pax.idPax]
			);
			const tierInfoindex = tierBenefits.findIndex(
				object => object[pax.idPax]
			);


			let paxfareAncillaries = fareInfoAncillary[fareInfoindex];
			let paxtierAncillaries = tierBenefits[tierInfoindex];
			let isFare = this.INDRA_filterBenefits(paxfareAncillaries, paxtierAncillaries, pax.idPax);
			if (isFare) {
				this.paxFareInfoFeatures.push({
					[pax.idPax]: this.INDRA_constructAncillaryList(paxfareAncillaries[pax.idPax])
				});
				this.paxTierBenefits.push({
					[pax.idPax]: ''
				});
			} else {
				this.paxFareInfoFeatures.push({
					[pax.idPax]: ''
				});
				this.paxTierBenefits.push({
					[pax.idPax]: this.INDRA_constructAncillaryList(paxtierAncillaries[pax.idPax])
				});
			}

			const purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(
				object => object[pax.idPax]
			);
			if (purchasedIndex === -1) {
				this.paxPurchaseFeatures.push({
					[pax.idPax] : []
				});
			} else {
				let paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
				this.paxPurchaseFeatures.push({
					[pax.idPax] : this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[pax.idPax])
				});
				//sort ascending based on segmentID
				this.paxPurchaseFeatures.sort((first, second) =>  (Number(first.segmentId) > Number(second.segmentId) ? -1 : 1));
			}
		});
	}

	INDRA_filterBenefits(fareList: any, tierList: any, idPax: number) {
		let fareAncillary = fareList[idPax][0];
		let tierAncillary = tierList[idPax][0];

		if (fareAncillary) {
			fareAncillary = fareAncillary.toString().replace('KIOSK', '');
		} else {
			fareAncillary = '';
		}

		if (tierAncillary) {
			tierAncillary = tierAncillary.toString().replace('KIOSK', '');
		} else {
			tierAncillary = '';
		}

		if (fareAncillary.length === 0 && tierAncillary.length === 0) {
			return true;
		} else if (fareAncillary.length < tierAncillary.length) {
			return false;
		} else if (fareAncillary.length === tierAncillary.length) {
			fareAncillary = fareAncillary.toString().replace('x', '');
			tierAncillary = tierAncillary.toString().replace('x', '');
			if (Number(fareAncillary) < Number(tierAncillary)) {
				return false;
			}
		}

		return true;
	}

	INDRA_constructAncillaryList(list: string[]) {
		let returnValue = '';
		list.forEach(item => {
			if (item) {
				returnValue = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + item}`);
			}

		});

		return returnValue;
	}

	INDRA_displaySegmentInfo(segmentId: string) {
		let returnValue = '';
		if (this.hasLayover) {
			let segmentInfo: INDRASegment = this.bookingService.INDRA_getSegment(this.flightIdentifier, segmentId);
			let segmentDeparture = this.bookingService.INDRA_getLocation(segmentInfo.departureAirport);
			let segmentArrival = this.bookingService.INDRA_getLocation(segmentInfo.arrivalAirport);
			returnValue = ' ' + segmentDeparture.city + ' - ' + segmentArrival.city;
		}
		return returnValue;
	}

	INDRA_getPurchasedAncillaryForPassenger(idPax: number): string[] {
		let returnValue: string[] = [];
		const index = this.paxPurchaseFeatures.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (this.paxPurchaseFeatures) {
			let paxAncillary = this.paxPurchaseFeatures[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_getGroupLabel() {
		let groupList: string[] = ANCILLARY_GROUP_KIOSK_LIST;
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_GROUP + groupList[0]}`);
	}
	INDRA_capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

	INDRA_printPassengerName(pax: INDRAPax) {
		return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
	}

	INDRA_printBrand() {
		return this.brandDescription;
	}

	INDRA_getAncillaryForPassenger(list: any, idPax: number) {
		let returnValue;
		const index = list.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (list) {
			let paxAncillary = list[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}
	}

	INDRA_constructAncillaryListForPurchased(list: any[]): INDRAIncludedAncillaryDetailForSegment[] {
		let returnValue: INDRAIncludedAncillaryDetailForSegment[] = [];
		list.forEach(segment => {
			let descriptionForSegment = '';
			// flag for unconfirmed codes
			let unconfirmed: boolean = false;
			segment.ancillaryList.forEach((ancillary: INDRAIncludedAncillaryCodeCount) => {
				if (ancillary.count > 1) {
					this.countUnit = this.INDRA_getTranslation('whatsIncludedSidebars.detailsKiosk.texts.countUnitPlural');
				} else {
					this.countUnit = this.INDRA_getTranslation('whatsIncludedSidebars.detailsKiosk.texts.countUnitSingular');
				}

				if (descriptionForSegment.length === 0) {
					descriptionForSegment = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
				} else {
					descriptionForSegment = descriptionForSegment + ', ' + ancillary.count + this.countUnit + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
				}

				// ANCILLARIES WARNING
				if (ancillary.unconfirmed) {
					unconfirmed = true;
				}

			});
			returnValue.push({
				ancillaryDetail: descriptionForSegment,
				segmentId: segment.segmentId,
				// ANCILLARIES WARNING
				unconfirmed: unconfirmed
			});
		});

		return returnValue;
	}

	INDRA_getAncillaryFareAndTierForPassenger(list: any, list1: any, idPax: number) {
		let returnValue;
		const index = list1.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (list1) {
			let paxAncillary = list1[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}

	}

	INDRA_getTranslationKey(lastKey: string, keyType: string) {
		return this.LOCAL_TRANSLATION_DETAILED_KIOSK + keyType + "." + lastKey;
	}

	INDRA_checkIndirectFlight() {
		const segments: string[] = this.bookingService.INDRA_getSegmentIDs(this.flightIdentifier);
		let flag = false;
		if (segments.length > 1) {
			flag = true;
		}
		return flag;
	}

	INDRA_redirectToUrl(key: string) {
		return window.open(this.ibeAdminConfigService.getConfigurationValue(key));
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_getPassengerTierLabel(pax: INDRAPax) {
		return this.bookingService.INDRA_getTierKeyLabel(pax);
	}
	
	INDRA_printImage() {
		const IMAGE = 'digital_kiosk.jpg';
		return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
	}
	
	INDRA_getBrandDescription() {
		if (this.isBookingView || this.isReviewTTTCompletion) {
			if (!this.flight.fareFamily) return '';
			const brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
			return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
		} else {
			this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
		}
	}
	
	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }
}
